import { FC } from 'react';
import { useShowContext } from 'framework/show';
import { useDateService } from 'framework/utils';
import { ProcessedLeaveYear } from '../../shared/types';

type BalanceFieldName = keyof Pick<
  ProcessedLeaveYear,
  'paidLeavesTotalBalance' | 'paidLeavesRemainedBalance' | 'sickDaysTotalBalance' | 'sickDaysRemainedBalance'
>;

type DayOnDemandFieldName = keyof Pick<ProcessedLeaveYear, 'dayOnDemandsTotalBalance' | 'dayOnDemandsRemainedBalance'>;

interface BalanceDisplayFieldProps {
  balanceField: BalanceFieldName;
  dayOnDemandField?: DayOnDemandFieldName;
}

const formatBalance = (balance?: string) => balance ?? '';

const BalanceDisplayField: FC<BalanceDisplayFieldProps> = ({ balanceField, dayOnDemandField }) => {
  const { data } = useShowContext<ProcessedLeaveYear>();
  const period = data?.getData();
  const { isCurrentTimeInPeriod } = useDateService();
  const isCurrentYearPeriod = isCurrentTimeInPeriod(period?.startDate, period?.endDate);

  if (!period) return null;
  if (period.hideBalanceColumns) return null;

  if (
    dayOnDemandField &&
    period.hasDayOnDemandBalance &&
    isCurrentYearPeriod &&
    period[dayOnDemandField] &&
    period[balanceField]
  ) {
    return (
      <span>
        {formatBalance(period[balanceField])}d/{formatBalance(period[dayOnDemandField])}d on demand
      </span>
    );
  }

  if (!period[balanceField]) return null;

  return <span>{formatBalance(period[balanceField])}d</span>;
};

export default BalanceDisplayField;
